<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
        :is-edit-settings="true"
        :send-all-form="true"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import addCollectionsToScheme from "@/utils/addCollectionsToScheme";
import {
  postMainBanner as updateData,
  getMainBanner as fetchData,
} from "@/api/mainBanner";
import { MainBannerUpdate as defaultScheme } from "@/api/schemes/mainBanner";

const updateScheme = async (scheme) => {
  try {
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        updateData,
        fetchData,
        updateScheme,
      },
    };
  },
};
</script>
